/*
 * Amberden — the shop page's filter (sections/amberden-shop.liquid, 2026-11-02).
 *
 * Shows All, Cordless or Corded by each card's data-kind (the product's cordless/corded tag). The page opens
 * filtered from ?kind=cordless or ?kind=corded (the footer's links), and the address follows the filter so it can
 * be shared. On lamps in several finishes, a swatch swaps its card to that finish: the photograph pair, the price,
 * the material line and both links. Hover previews on a mouse; a tap or click chooses.
 */
(function () {
  function choose(card, btn) {
    var id = btn.getAttribute('data-finish');
    card.querySelectorAll('.frame[data-finish]').forEach(function (f) {
      f.hidden = f.getAttribute('data-finish') !== id;
    });
    card.querySelectorAll('[data-amb-card-link]').forEach(function (a) { a.href = btn.getAttribute('data-url'); });
    var price = card.querySelector('[data-amb-card-price]');
    if (price) price.textContent = btn.getAttribute('data-price');
    var mat = card.querySelector('[data-amb-card-material]');
    if (mat) mat.textContent = btn.getAttribute('data-material');
    card.querySelectorAll('.amb-card__finishes button').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-amb-card]').forEach(function (card) {
    card.querySelectorAll('.amb-card__finishes button').forEach(function (btn) {
      btn.addEventListener('click', function () { choose(card, btn); });
      btn.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover)').matches) choose(card, btn);
      });
    });
  });

  var filter = document.querySelector('[data-amb-shop-filter]');
  if (!filter) return;
  function apply(btn, remember) {
    var kind = btn.getAttribute('data-kind');
    filter.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    document.querySelectorAll('[data-amb-card]').forEach(function (card) {
      card.hidden = kind !== '' && card.getAttribute('data-kind') !== kind;
    });
    if (remember && window.history && history.replaceState) {
      var url = new URL(window.location.href);
      if (kind) url.searchParams.set('kind', kind); else url.searchParams.delete('kind');
      url.hash = '';
      history.replaceState(null, '', url);
    }
  }
  filter.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-kind]');
    if (btn) apply(btn, true);
  });
  var wanted = new URLSearchParams(window.location.search).get('kind');
  if (wanted) {
    var start = filter.querySelector('button[data-kind="' + wanted + '"]');
    if (start) apply(start, false);
  }
})();
